<template>
  <div class="container">
    <event-details v-if="event" :event="event"/>
  </div>
</template>

<script>
  import api from '@/api'

  export default {
    metaInfo () {
      const eventCode = this.event ? this.event.code : ''
      return {title: `Событие ${eventCode}`}
    },
    props: {
      id: {},
    },
    data () {
      return {}
    },
    asyncComputed: {
      event () {
        return api
          .get(`events/${this.id}`)
          .then(({data}) => data)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/reports/events/_id.vue